@import "../../../../../globalStyles/commons";

:host {
  display: block;
  height: 100%;
  --calendar-border-color: var(--field);
  --scale-size: 4rem;
  --scale-color: var(--layer-accent)
}

.scale {
  width: var(--scale-size);
}

.calendar-column-view {
  display: flex;
  flex-direction: column;
  height: 100%;

  .view-header {
    display: flex;
    background: var(--layer-accent);

    .columns {
      display: flex;
      flex: 1;

      .column {
        flex: 1;
        border-inline-start: 1px solid var(--calendar-border-color);


        .column-content {
          display: flex;
          border-top: .5rem solid transparent;
          align-items: center;
          padding: .5rem;
          gap: .5rem;
        }

        &.today {
          .column-content {
            border-top-color: v(--color-primary);

            .date {
              color: v(--color-primary);
            }
          }
        }

        .date {
          font-size: 1.5rem;
          cursor: pointer;
          border-radius: 100%;
          padding: 0.5rem;
          width: 3rem;
          height: 3rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .day {
          @include font-style(heading-compact-01);
        }
      }
    }

    .scrollbar-placeholder {
      width: var(--scrollbar-width);
    }
  }

  .multi-day-section-wrapper {
    background: var(--layer-accent);

    .multi-day-section-scroll {
      overflow-y: scroll;
      max-height: 6rem;

      .multi-day-section {
        position: relative;

        .multi-day-background {
          display: flex;
          height: 100%;
          position: absolute;
          width: 100%;

          .columns {
            display: flex;
            flex: 1;

            .column {
              flex: 1;
              border-inline-start: 1px solid var(--calendar-border-color);
            }
          }
        }

        .multi-events {
          padding: 0 0 0 var(--scale-size);


          .row {
            height: 1.8rem;
            box-sizing: content-box;
            position: relative;
            padding-bottom: .5rem;

            &:last-child {
              padding-bottom: 0;
            }
          }

          .row-spacer {
            height: 1rem;
          }

          .event {
            position: absolute;
            height: 1.8rem;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }
  }

  .view-body {
    height: 100%;
    border-bottom: 1px solid var(--calendar-border-color);
    overflow-y: scroll;

    .view-body-scroll {
      display: flex;
      position: relative;

      .scale {
        border-right: 1px solid var(--scale-color);

        .background {
          border-inline-start: 1rem;
        }

        .row {
          width: 0;
          position: relative;
          height: 2rem;
          border-bottom: 1px dashed var(--scale-color);

          &.hour {
            border-bottom: 1px solid var(--scale-color);
            width: 50%;
            margin-inline-start: 50%;
          }

          &:last-child {
            border-bottom: 0;
          }

          .time {
            position: absolute;
            top: -.5rem;
            font-size: .75rem;
          }
        }
      }

      .drawing-area {
        flex: 1;

        .events-container {
          position: absolute;
          top: 0;
          left: var(--scale-size);
          width: calc(100% - var(--scale-size));
          height: 100%;
          display: flex;

          .column {
            flex: 1;
            padding: 0 1rem 0 1px;

            .column-content {
              position: relative;
              height: 100%;
            }

            .event {
              position: absolute;
            }
          }
        }
      }

      .current-time-line {
        position: absolute;
        z-index: 100;
        pointer-events: none;
        width: calc(100% - var(--scale-size));
        margin-inline-start: var(--scale-size);

        .time {
          position: absolute;
          font-size: .5rem;
          font-weight: 600;
          color: v(--color-primary);
          top: -6px;
          left: -3rem;
          background: v(--color-primary-10);
          padding: 2px;
          border-radius: 3px;
        }

        .dash-line {
          position: absolute;
          left: 0;
          border-bottom: 1px dashed v(--color-primary);
        }

        .dot {
          border-radius: 100%;
          width: 0.5rem;
          height: 0.5rem;
          background: v(--color-primary);
          display: block;
          position: absolute;
          top: -0.25rem;
        }

        .line {
          border-bottom: 2px solid v(--color-primary);
          position: absolute;
          top: -1px;
        }
      }
    }
  }
}



/*
 * Common color styles for event
 */
.calendar-column-view {
  .date {
    &:hover {
      background: v(--color-brand-primary-10);
    }
  }
}

.event {
  background: var(--calendar-event-bg-color);
  border-inline-start: .35rem solid var(--calendar-event-border-color);

  .event-title {
    padding: 0.25rem;
    @include font-style(body-01);
  }

  &.clickable {
    cursor: pointer;

    &:hover {
      background: var(--calendar-event-bg-color--hover);
    }
  }
}



:host-context([data-theme="dark"]) {

  .calendar-column-view {
    .date {
      &:hover {
        background: v(--color-brand-primary-90);
      }
    }
  }


  .event {
    background: var(--calendar-event-dark-bg-color);
    &.clickable {
      &:hover {
        background: var(--calendar-event-dark-bg-color--hover);
      }
    }
  }

}
